











import { Component, Prop, Vue } from "vue-property-decorator";
import { PlayersType, PlayerInfoNumberType } from "@/types";
import PlayerTag from "@/components/game/PlayerTag.vue";

@Component({ components: { PlayerTag } })
export default class Scoreboard extends Vue {
  @Prop({ required: true }) scores!: PlayerInfoNumberType;
  @Prop({ required: true }) playerId!: string;
  @Prop({ required: true }) players!: PlayersType;

  score(playerId: string) {
    return this.scores[playerId] || 0;
  }

  get playersArray() {
    return Object.values(this.players).sort((a, b) => {
      const scoreA = a ? this.score(a.id) : 0;
      const scoreB = b ? this.score(b.id) : 0;
      if (scoreA > scoreB) return -1;
      if (scoreA < scoreB) return 1;
      return 0;
    });
  }
}
